import { useResize } from '@algoan/dashboard/utils';
import { S } from './style';
import { firstDayOffset } from './events';

export const Tick: React.FC<{ daySpacing: number; day: number; label: string }> = ({ daySpacing, day, label }) => {
  const { width, elementRef } = useResize();

  return (
    <S.Tick ref={elementRef} daySpacing={daySpacing} day={firstDayOffset + day} elementWidth={width}>
      <S.TickBar />
      <S.TickLabel>{label}</S.TickLabel>
    </S.Tick>
  );
};
